export const WIZARD_ROOT_PATH = "wizard";

export const WIZARD_STEP_PATH = {
  ACCOUNT_SELECTION: "account-selection",
  SELECT_SOURCE: "select-source",
  SELECT_TARGET: "select-target",
  ENTITIES_SELECTION: "entities-selection",
  OPTIONS_SELECTION: "options-selection",
  MAPPING_SETUP: "mappings-setup",
  DEMO_MIGRATION: "demo-migration",
  FINISH: "finish",
};

export const WIZARD_STEP_NAME = {
  ACCOUNT_SELECTION: "Account Selection",
  SELECT_SOURCE: "Source Store Setup",
  SELECT_TARGET: "Target Store Setup",
  ENTITIES_SELECTION: "Entities Selection",
  OPTIONS_SELECTION: "Additional Options",
  MAPPING_SETUP: "Mapping Setup",
  DEMO_MIGRATION: "Demo Results Review",
  FINISH: "Finish",
};

export const WIZARD_BUTTON_NAME = {
  UPLOAD_FILES: "Upload Files",
  START_RECENT: "Start Recent Data Migration",
  START_REMIGRATION: "Start Remigration",
  START_DEMO: "Start Demo Migration",
  DEMO_PROGRESS: "Demo Migration Process",
  DEMO_RESULTS: "Demo Results Review",
  START_FULL: "Start Full Migration",
  RECONFIGURE: "Reconfigure Target Store",
};
